import { Component, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConnectivityService } from '@/offline/connectivity.service';

@Component({
    selector: 'app-sync-status-badge',
    imports: [RouterModule],
    templateUrl: './sync-status-badge.component.html',
})
export class SyncStatusBadgeComponent {

    private connectivity = inject(ConnectivityService);

    /** Real backend reachability (see ConnectivityService), not just navigator.onLine. */
    online = this.connectivity.backendOnline;

    dismissed = signal(false);

    constructor() {
        // Una reconexión (o una nueva caída tras haberla cerrado) vuelve a mostrar la pill
        // aunque el usuario la hubiera cerrado en el estado anterior.
        effect(() => {
            this.online();
            this.dismissed.set(false);
        });
    }

    dismiss(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.dismissed.set(true);
    }
}
